import { memo } from 'react';

// Confettis CSS (zéro dépendance). Variation déterministe par index (pas de Math.random).
const COLORS = ['#29B6E8', '#F97316', '#FFB938', '#22c55e', '#ef4444', '#8b5cf6', '#ec4899'];
const PIECES = Array.from({ length: 44 }, (_, i) => i);

const Confetti = memo(function Confetti() {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
      {PIECES.map((i) => {
        const left = (i * 37) % 100;
        const color = COLORS[i % COLORS.length];
        const dur = 1.6 + ((i * 13) % 12) / 10; // 1.6–2.8s
        const delay = ((i * 7) % 10) / 10;       // 0–0.9s
        const w = 7 + (i % 4) * 2;
        return (
          <span
            key={i}
            className="xp-confetti-piece"
            style={{ left: `${left}%`, background: color, width: w, height: w * 1.6, animationDuration: `${dur}s`, animationDelay: `${delay}s` }}
          />
        );
      })}
    </div>
  );
});

export default Confetti;
